/**
 *
 * @type {{courses: string, submit: string, password_label: string, about: string, create_an_account: string, my_profile: string, required: string, log_in: string, email_label: string, country_label: string, existing_user: string, explore_courses: string, sign_in: string, sign_out: string}}
 */
const common = {
  app_title: 'Mid-Level Management Online Training',
  explore_courses: 'Explore Courses',
  create_an_account: 'Create an account',
  existing_user: 'Existing user?',
  log_in: 'Log in',
  sign_in: 'Sign in',
  sign_out: 'Sign out',
  my_profile: 'My Profile',
  courses: 'Courses',
  about: 'About',
  submit: 'Submit',
  email_label: 'Email',
  country_label: 'Country',
  required: 'All fields required',
  password_label: 'Password',
  undo: 'Undo',
  retry: 'Retry',
  course_sequence_name: 'Course {sequence}: {name}',
  newest: 'Newest',
  most_popular: 'Most Popular',
  first_name_label: 'First Name',
  last_name_label: 'Surname',
  role_label: 'Role',
  role_name_label: 'Role Name',
  photo: 'Photo',
  upload_new: 'Upload new',
  continue_: 'Continue',
  required_field_message: 'This field is required',
  dismiss: 'Dismiss',
  expired_session_message: 'Your session has expired. Please log in again',
  saved: 'Saved',
  yes: 'Yes',
 




};

/**
 *
 * @type {{h1: string}}
 */
const nav = {
  h1: 'MLM Online Training'
};

/**
 *
 * @type {{subscribe_label: string, subscribe: string, who_office: string, links: string, telephone: string, fax: string, updates: string, subscribe_placeholder: string}}
 */
const footer = {
  links: 'Links',
  who_office: 'World Health Organization - Regional Office for Africa Cité du Djoué, P.O.Box 06 Brazzaville Republic of Congo',
  telephone: 'Telephone',
  fax: 'Fax',
  updates: 'Updates',
  subscribe_label: 'Please subscribe to receive updates on things related to the MLM courses.',
  subscribe: 'Subscribe',
  subscribe_placeholder: 'Your email address',
  subscribe_success_message: 'Your request to be added to the mailing list has been sent',
};

/**
 *
 * @type {{p: string, enroll_course: {small: string, p: string, h3: string}, h1: string, enroll_master: {small: string, p: string, h3: string}, h3: string, welcome: string}}
 */
const home_page = {
  welcome: 'Welcome to',
  h1: 'EPI Mid-Level Management Online Training',
  line_1: `
  Advance your career by learning the essential technical and managerial skills needed to run an immunization
  program at any level. MLM training is now available as a series of 15 interactive online courses
  that individuals may take for free, at their own pace, whenever and wherever they choose.
  `,
  line_2: `
  In each course, learners gain hands-on practice by working with realistic scenarios and examples.
  After each course, learners earn certification from WHO AFRO, enabling higher performance on
  the job and the potential for career advancement.
  `,
  enroll_master: {
    small: 'TAKE ALL 15 COURSES',
    h3: 'Enroll in the Master Program',
    p: `
      Enroll in the MLM Master Program if you are interested in taking all 15 online courses and
      mastering all the skills necessary to lead and operate an immunisation program.
      Take all the time you need to complete the program, one course at a time.
    `,
  },
  enroll_course: {
    small: 'TAKE INDIVIDUAL COURSES',
    h3: 'Enroll in One Course at a Time',
    p: `
      Sign up for one or more online courses. You can take as few or as many as you like, to learn or
      improve your skills. Enroll in additional courses at any time and take as long as you need. If you
      eventually take all 15 courses, you will earn master certification.
    `,
  },
  h3: 'Improve your on-the-job performance with MLM Online Training courses'
};

/**
 *
 * @type {{frequently_asked_questions: string, faqs: {"0": {head: string, body: string}, "1": {head: string, body: string}, "2": {head: string, body: string}, "3": {head: string, body: string}, "4": {head: string, body: string}, "5": {head: string, body: string}}, h1: string}}
 */
const help_page = {
  h1: 'Help',
  frequently_asked_questions: 'Frequently Asked Questions',
  faqs: {
    0: {
      slug: 'technology',
      head: 'What technology do you need to complete the courses?',
      body: `
      <p class="text-sm lg:text-base lg:w-9/12 py-3">
      You will need to be connected to the internet to take a course. In
      addition, these courses are designed to be taken on a desktop or
      laptop computer using a recent version of Chrome, Safari or Firefox.
      <strong
        >Please note that internet speeds may influence your ability to
        move through the course modules</strong
      >.
        </p>
      `,
      subcategories: [
      ]
    },
    1: {
      slug: 'advancing',
      type: 'plain',
      head: 'Are you having trouble entering an answer or advancing to the next activity?',
      body: ``,
      subcategories: [
          {
              slug: 'internet',
              head: 'Internet',
              body: `This is an internet problem. Please note that internet speeds may 
              influence your ability to move through the course. 
              If you are finding that you are having trouble continuing to the next screen, 
              <strong>check your internet connection, clear your cache, and refresh your page accordingly.</strong>`
          }
      ]
    },
    2: {
      slug: 'understanding',
      type: 'columns',
      head: 'Are you having trouble understanding the course content?',
      body: ``,
      subcategories: [
          {slug: 'hint',
           head: 'Use the “Hint” function',
           image: 'help-hint.jpg',
           body: `
           We encourage you to use the <strong>“hint”</strong> functions,
                when they are available. If you no longer have any more “hints”
                available, you can restart the activity and your
                <strong>“hints”</strong> will reset. It will be helpful to write
                down the answers you have already completed prior to restarting
                the activity. Only the current activity will reset; your
                previous progress will remain intact.
           `},
           {slug: 'discussionboard',
           head: 'Use the Discussion Board',
           image: 'help-discussionboard.jpg',
           body: `
           If you were not able to derive the answer from the “hints”
                provided, we encourage you to read through the comments posted
                in the discussion board within the course you are completing.
                Your peers may have encountered the same problem and offered
                solutions. If you do not see any suggestions from your peers,
                post a question in the discussion board.
           `},
           {slug: 'resources',
           head: 'Use Course Resources',
           image: 'help-resources.jpg',
           body: `
           Each course contains a “Resources” section. Here you will find
           several WHO-approved supplementary material available to
           download. If you are having trouble understanding a course, or
           if you have questions beyond the scope of the course, please
           review the provided resources.
           `},
           {slug: 'content',
           head: 'Did you identify an error in the content?',
           body: `
           The MLM courses are based on WHO-approved guidance documents, which are reviewed and updated at regular intervals. Additionally, all course content has been carefully reviewed by WHO subject matter experts. If you think you have identified an error, start by posting a comment on the discussion board and ask your peers for their input.
           `},
      ]
    },
    3: {
      slug: 'howworks',
      type: 'stacked',
      head: 'How does MLM Online work?',
      body: ``,
      subcategories: [
          {
              slug: 'enroll',
              head: 'How do you enroll in a course?',
              image: 'help-enroll.jpg',
              body: `<p class="mb-4">
              To enroll in a course, click on the orange “Enroll” button.
              You may sign up for one or more courses that you are
              interested in, or you may decide to commit to taking all 15
              MLM courses for master certification. It is your choice.
            </p>
            <p>
              Once you click the Enroll button, you will be asked to provide
              some registration information about yourself, your role and
              location. Then you can begin taking the course.
            </p>`,

          },
          {
            slug: 'earn',
            head: 'How do you earn a course certificate?',
            image: '',
            body: `<p class="mb-4">
            You will receive a formal certificate from the WHO Regional
            Office for Africa immediately after you complete a course and
            pass the assessment.
            <strong
              >You will need to score at least 80% in order to pass.</strong
            >
            You will receive a certificate for each course you complete. For
            example, if you complete three courses, you will receive three
            separate certificates.
          </p>`,

        },
        {
            slug: 'access',
            head: 'How do you access your certificate?',
            image: 'help-completed.jpg',
            body: `<p class="mb-4">
            Once you have passed an assessment, you will see the course
            listed on your dashboard under “Completed Courses.” Beside the
            completed course, you will see a button to click to download
            your certificate.
          </p>`,

        },
        {
            slug: 'master',
            head: 'How do you earn master certification?',
            image: 'help-downloadmaster.jpg',
            body: `<p class="mb-4">
            If you have completed all 15 MLM courses, your master certification will appear at the top of the "courses" page.  
            If you are still unable to access your certificate, it is likely that you received an assessment score <strong>lower than 80%</strong>. 
            Please review your scores on all 15 courses to confirm that you received a passing score. 
            Once you have completed all 15 MLM courses, <strong>a link to download your certificate will become available below the image of the green trophy in your 
            "Courses" page.</strong>  
        </p>
        <p class="mb-4">This link will take you to your master certification: <a href="/en/courses">https://app.who-afro-mlm.com/en/courses</a> </p>
        `,

        },
      ]
    },
    4: {
        slug: 'profile',
        type: 'double-stacked',
      head: 'Do you need to update your name, password, photo, or role?',
      body: ``,
      subcategories: [
          {
              slug: 'name',
              head: 'To change the name that appears on your certificate',
              body: `<ul class="mb-4 list-disc ml-5">
              <li class="mb-2">Log in to your MLM account</li> 
              <li class="mb-2">Click on your Name (displayed
              on the top right corner of the page).</li> 
              <li class="mb-2">Select “Edit Profile.”</li>
              <li class="mb-2">In the field titled “Name,” enter your name as you would
              like it to appear on your MLM certificate.</li> 
              <li class="mb-2">To avoid changing
              your password, do not type anything into the “Reset Password”
              section.</li> 
              <li class="mb-2">We also encourage you to upload a profile picture
              to your account!</li> 
              <li class="mb-2">Save your changes by clicking the “Save
              Changes” button. Please note that the name in your account
              will appear on your certificate. You may go into your account
              and change your name, however please note that this may be
              done only one time in a span of 3 months.</li>
              </ul>`,
              image: 'help-profile.jpg',
              hiddenimage2: 'help-profile-editprofile.jpg'
          },
          
        {
            slug: 'password',
            head: 'To reset your password',
            body: `<ul class="mb-4 list-disc ml-5">
            <li class="mb-2">Please visit the MLM website and click “log in.” </li>
            <li class="mb-2">Then click on the blue text that says “Forgot your password?” </li>
            <li class="mb-2">Once you enter your email and click the orange reset button,
          you will receive an email instructing you on how to reset your
          password. </li>
          <li class="mb-2">Once this is completed, you will be able to log in
          to your account.</li>
        </ul>`,
            image: 'help-profile-editpassword.jpg',
            hiddenimage1: 'help-profile.jpg'
        },
        {
          slug: 'photo',
          head: 'To change your photo or role',
          body: `<ul class="mb-4 list-disc ml-5">
          <li class="mb-2">Log in to your MLM account</li> 
          <li class="mb-2">Click on your Name in the top right corner of the page.</li> 
          <li class="mb-2">Select “Edit Profile.”</li> 
          <li class="mb-2">To add or change your photo, select “Upload new photo.”
          </li> 
          <li class="mb-2">To add or change your role, select the drop-down menu titled “Role.”</li>
        </ul>`,
          image: 'help-profile-editprofile.jpg',
          hiddenimage1: 'help-profile.jpg'
      },
      ]
    },
  }
};

/**
 *
 * @type {{"0": {p: string, button: string, h1: string}, "1": {p: string, button: string, h1: string}}}
 */
const about_page = {
    section_1: {
      h1: 'About MLM Courses',
      p: `
        Improve your on-the-job performance by taking one or more of the 15 individual courses listed below.
        In each course, you’ll gain relevant practice, individualized feedback, a set of WHO
        resources and worksheets, and access to a community of learners just like you.
        Click on any course to see what is covered. Then start learning.
      `,
      button: 'Go To Courses'
    },
    section_2: {
      h1: 'Next-Level Certification with the MLM Masters Program',
      line_1: `
      Enhance your career by enrolling in the MLM Master Program. Once you enroll,
      you’ll be automatically signed up for all 15 courses shown below.
      Take all the time you need to complete the coursework.
      `,
      line_2: `
      Throughout the program, you will gain relevant practice, individualized feedback,
      a set of WHO resources and worksheets, and access to a community of learners just like you.
      When finished, you will earn Master Certification from WHO AFRO,
      a designation that demonstrates your mastery and commitment.
      `,
      button: 'Explore All Courses'
    },
  };

/**
 *
 * @type {{est_time: string, you_are_enrolled: string, completed_courses: string, all_mlm_courses: string, view_details: string, enroll_master: string, enrolled_courses: string, enroll_in_courses: string, complete_the_remaining_n_courses: string, what_do_you_want_to_learn_about: string, continue_course: string, course_sequence_name: string, you_have_completed_all_courses: string, you_can_retake_courses_anytime: string, search_error_message: string, download_master_cert: string, you_have_completed_n_courses: string, my_courses: string, mlm_master_cert: string, download_cert: string, course_sequence: string, improve_your_performance: string, see_your_courses_below: string, start_course: string, enroll_success_message: string, great_start: string, search_results: string, n_courses: string, progress: string, enroll: string}}
 */
const courses_page = {
  improve_your_performance: 'Improve your on-the-job performance with MLM Online Training courses',
  enroll_in_courses: 'Enroll in one of the courses below, or enroll in the MLM Master Certification program.',
  great_start: 'Creating an account is a great start! You are on your way to earning MLM certification.',
  you_are_enrolled: 'Success! You are enrolled in the MLM Master Certification program and on your way to getting certified.',
  see_your_courses_below: 'See your list of courses below.',
  n_courses: '{n} course | {n} courses',
  you_have_completed_n_courses: 'Keep up the good work! You have completed {courses} so far.',
  complete_the_remaining_n_courses: 'Complete the remaining {courses} to become MLM Master Certified.',
  you_have_completed_all_courses: 'Congratulations! You have completed all courses in the MLM Master Certification Program.',
  you_can_retake_courses_anytime: 'Don’t forget to keep your knowledge fresh. You can retake courses anytime.',
  download_master_cert: 'Download Master Certificate',
  download_cert: 'Download Certificate',
  search_results: 'Search Results',
  all_mlm_courses: 'All MLM Courses',
  what_do_you_want_to_learn_about: 'What do you what to learn about?',
  course_sequence: 'COURSE {sequence}',
  course_sequence_name: common.course_sequence_name,
  view_details: 'View details',
  est_time: 'Est. Time {time}',
  estimated_time: 'Estimated Time',
  enroll: 'Enroll',
  enroll_now: 'Enroll Now',
  mlm_master_cert: 'MLM Master Certification',
  enroll_master: `Enroll in all 15 courses at once. Take all the time you need to complete the coursework. When
                  you are finished, you will earn Master Certification from WHO AFRO.`,
  search_error_message: 'Your search did not return any modules. Please try another search.',
  my_courses: 'My Courses',
  enrolled_courses: 'Enrolled Courses',
  progress: 'Progress',
  completed_courses: 'Completed Courses',
  retake_course: 'Retake Course',
  continue_course: 'Continue Course',
  start_course: 'Start Course',
  enroll_success_message: 'You are enrolled in {course_sequence_name}',
  module_available_soon: 'This module will be available soon',
  master_enroll_error_message: 'An error occurred, some courses were not enrolled',
  master_un_enroll_error_message: 'An error occurred, some courses were not un-enrolled',
  master_enroll_success_message: 'You are enrolled in all 15 Courses',
  lessons: 'Lessons',
  view_my_results: 'View my results',
  course: 'Course',
  date_completed: 'Date Completed',
  results: 'Results',
  course_results: 'Course Results',
  for: 'for',
  new_courses: 'Beginning April 2021, a new course, titled 2YL and Beyond, will also be required for MLM master certification.',
};

/**
 *
 * @type {{return_to_my_courses: string, hide_menu: string, ask_your_question_below: string, ask_an_expert: string, ask_question_here: string, restart: string, start: string, submit_question: string, resources: string, show_menu: string, no_more_activities: string, ask_expert_success_message: string}}
 */
const course_page = {
  ask_expert_success_message: 'Your message has been sent',
  no_more_activities: 'There are no more activities in this course',
  hide_menu: 'Hide menu',
  show_menu: 'Show menu',
  restart: 'Restart',
  next_up: 'Next Up',
  start: 'Start',
  return_to_my_courses: 'Return to My Courses',
  resources: 'Resources',
  ask_an_expert: 'Ask an Expert',
  ask_your_question_below: 'Ask your question below to contact a subject matter expert and they will follow up shortly with an email.',
  ask_question_here: 'Ask a question here',
  submit_question: 'Submit Question',
  discussion_board: 'Discussion Board',
  add_comment: 'Add comment',
  sort_by: 'Sort by:',
  view_n_more_comments: 'View {n} more comments',
  reply: 'Reply',
  reply_to_author: 'Reply to @{author}',
  share: 'Share',
  like_this: 'Like this',
  liked: 'Liked',
  need_help: 'Need Help?',
};

/**
 *
 * @type {{profile_information: string, edit_profile: string}}
 */
const profile_page = {
  edit_profile: 'Edit profile',
  profile_information: 'Profile Information',
};

/**
 *
 * @type {{}}
 */
const profile_edit_page = {
  profile_settings: 'Profile Settings',
  profile: 'Profile',
  reset_password: 'Reset Password',
  return_to_profile: 'Return to profile',
  first_name_label: common.first_name_label,
  last_name_label: common.last_name_label,
  country_label: common.country_label,
  role_label: common.role_label,
  role_name_label: common.role_name_label,
  email_label: 'Email Address',
  mobile_phone_label: 'Mobile Phone',
  save_changes: 'Save changes',
  cancel: 'Cancel',
  new_password_label: 'New Password',
  confirm_password_label: 'Confirm Password',
  reset_success_response: 'Your reset link has been sent! Please check your email.',
  send_reset_link: 'Send reset link'
};

/**
 *
 * @type {{}}
 */
const survey_page = {
  please_message: 'Please complete this survey based on your experiences since taking the course.',
  thanks_message: 'Thank you for completing the survey.',
  h1: '{name}, you have successfully completed {module}',
  h2: 'WHO AFRO MLM Training: Online Survey',
  line_1: 'This small survey will help The WHO AFRO IVD program to better understand how the MLM course material is utilized in the day-to-day work of mid-level immunization program managers.',
  line_2: `In addition, this step has been built in as a requirement in order to receive certification for the
  training. We kindly ask that you complete this 9-question survey, which takes no more than 10
  minutes. Once you complete the survey, you will receive certification from WHO AFRO for the
  completed training.`,
  line_3: 'Thank you for taking your time to provide your experiences.',
  capable_label_line_1: 'To what extent did this MLM online course make you feel more capable of doing your job?',
  capable_label_line_2: 'Please rate from Less Capable (1) to Most Capable (10)',
  swipe_to_see_more: 'Swipe to see more',
  less_capable: 'less capable',
  most_capable: 'most capable',
  ways_used_line_1: 'Think about your work experiences over the past two months. In what way have you used the skills and knowledge you gained through this online module in your daily work?',
  ways_used_line_2: 'Provide an example that is as specific as possible.',
  write_your_answer_here: 'Write your answer here...',
  measurable_improvement_label: `
  In what {measurable_way} have you seen an improvement in
  the performance of your immunization program, as a result of your new skills and knowledge?`,
  measurable_way: 'measurable way',
  anything_else_label: 'Is there anything else you would like to share about the impact of the learning experience?',
  final_thanks: 'Thank you for your participation in this survey and your commitment to your profession. This was the final step of MLM training.'
};

/**
 *
 * @type {{}}
 */
const reset_page = {

};

/**
 *
 * @type {{thank_you: string, response_message: string, email_label: string, country_label: string, h1: string, h2: string, describe_label: string, required: string, name_label: string, title_label: string}}
 */
const contact_modal = {
  h1: 'Contact',
  h2: 'Contact an officer at WHO AFRO headquarters in Brazzaville. They will respond to your message as soon as possible.',
  required: common.required,
  name_label: 'Name',
  title_label: 'Title',
  email_label: common.email_label,
  country_label: common.country_label,
  describe_label: 'Describe Your Training Need',
  thank_you: 'Thank You',
  response_message: 'An officer at WHO AFRO headquarters in Brazzaville will respond to your message as soon as possible.',
};

/**
 *
 * @type {{role_name_label: string, register_now: string, last_name_label: string, basic_info: string, upload_new: string, password_label: string, first_name_label: string, h1: string, photo: string, h2: string, optional: string, contact_info: string, enroll_mlm_label: string, password_confirmation_label: string, registered_user: string, country_label: string, email_label: string, role_label: string, email_confirmation_label: string, sign_in: string}}
 */
const register_modal = {
  h1: 'Register to get started with MLM Online Training.',
  h2: 'This is how your name will appear on any certificates you receive, so please enter your name carefully.',
  registered_user: 'Registered user?',
  sign_in: 'Sign in here.',
  basic_info: 'Basic Information',
  contact_info: 'Contact Information',
  first_name_label: common.first_name_label,
  last_name_label: common.last_name_label,
  country_label: common.country_label,
  role_label: common.role_label,
  role_name_label: common.role_name_label,
  password_label: common.password_label,
  password_confirmation_label: 'Password Confirmation',
  email_label: common.email_label,
  email_confirmation_label: 'Confirm Email Address',
  photo: common.photo,
  optional: 'Optional',
  upload_new: common.upload_new,
  enroll_mlm_label: 'Enroll in the MLM Master Program',
  register_now: 'Register now',
};

/**
 *
 * @type {{email_label: string, password_label: string, or_register_an_account: string, h1: string, forgot_password: string}}
 */
const login_modal = {
  h1: 'Log in to your account',
  email_label: common.email_label,
  password_label: common.password_label,
  forgot_password: 'Forgot password',
  or_register_an_account: 'or Register an Account'
};

/**
 *
 * @type {{playback_step_1: string, playback_step_2: string, playback_step_3: string, back_btn_text: string, tour_btn_text: string, done_btn_text: string, start_step: string, next_btn_text: string, collaborate_step_2: string, collaborate_step_3: string, collaborate_step_4: string, collaborate_step_1_lg: string, collaborate_step_1_sm: string}}
 */
const tour = {
  start_step: 'Welcome to your first MLM Course!  Take the tour...',
  playback_step_1: 'Your course will appear in this area.',
  playback_step_2: 'During a course, click the NEXT button to advance to the next screen of the course.',
  playback_step_3: 'You may restart or revisit any section of the course by clicking on it.',
  collaborate_step_1_sm: 'You may show/hide all sections of the course by clicking here.',
  collaborate_step_1_lg: 'Make the course fill your screen by clicking here.',
  collaborate_step_2: 'Share your questions, knowledge, and tips with other EPI professionals taking this course with you.',
  collaborate_step_3: 'Each course includes useful resources that you may need. Download them by clicking these icons.',
  collaborate_step_4: 'If you cannot find the answers you need by talking with others on the Discussion Board, we recommend that you visit the online Help Page ',
  tour_btn_text: 'Take the tour',
  back_btn_text: 'Back',
  next_btn_text: 'Next',
  done_btn_text: 'Done',
};

const workshops = {
  heading: 'EPI Mid-Level Managers training has been redesigned to be more effective, flexible, and interactive. Each module now exists as a workshop and an online emodule – in English, French and Portuguese. Download any workshop materials below.',
  redesigned_workshops: 'Redesigned workshops',
  number_workshops: '17 modularized workshops that can be delivered in any combination',
  guides: 'Facilitator’s and participant’s guides',
  instructions: 'Minute-by-minute instructions for facilitators leading each workshop',
  specific_points: 'Specific exercises, activities, and lecture points',
  structured_pedagogy: 'Structured pedagogy support throughout',
  workshops: 'Workshops',
  download_materials: 'Download materials',
  online_curriculum: 'An online curriculum',
  same_content: 'Same content as the workshops',
  self_paced: 'Self-paced learning',
  highly_modular: 'Highly modular',
  go_to: 'Go to the MLM Online Training',
  courses: 'Courses',
  about: 'About',
  help: 'Help',
  address: 'World Health Organization - Regional Office for Africa Cité du Djoué, P.O. Box 06 Brazzaville Republic of Congo',
  telephone: 'Telephone',
  fax: 'Fax',
}

/**
 *
 */
export default {
  ...common,
  nav,
  footer,
  home_page,
  help_page,
  about_page,
  courses_page,
  course_page,
  profile_page,
  profile_edit_page,
  survey_page,
  reset_page,
  contact_modal,
  register_modal,
  login_modal,
  tour,
  workshops,
}